export default __webpack_public_path__ + "static/DSC_0101-b41c2bfb80801053dd77ccb373ab8ec3.jpg";